import { defaultPulsechainProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/pulsechain/default-constants';

export const PULSEX_V1_CONTRACT_ADDRESS = '0x98bf93ebf5c380C0e6Ae8e192A7e2AE08edAcc02';

export const PULSEX_V1_PROVIDER_CONFIGURATION = defaultPulsechainProviderConfiguration;
